import { Avatar, type AvatarProps } from 'antd'

import { getInitials, stringToHslColor } from 'src/utils'

import { useStyles } from './styles'

type Props = {
  name: string
  id?: number
  size?: number
  initialsFontSize?: number
} & AvatarProps

export const AvatarWithInitials = ({
  name,
  id,
  size = 64,
  initialsFontSize = 14,
  ...props
}: Props) => {
  const initials = getInitials(name)
  const bgColor = props.src
    ? 'transparent'
    : stringToHslColor(id ? `${name}-${id}` : name)

  const { styles } = useStyles({ bgColor, initialsFontSize })

  return (
    <Avatar size={size} className={styles.avatar} {...props}>
      {initials}
    </Avatar>
  )
}
